import {
   EXECUTE_FLOW,
   SET_FLOW_EXECUTION_FAILED,
   SET_FLOW_EXECUTION_FAILED_RESET,
   ADD_EXECUTION_REPORT,
   HIDE_FLOW_USAGE_DIALOG,
   SHOW_FLOW_USAGE_DIALOG,
   CANCEL_FLOW_EXECUTION,
   FETCH_EXECUTION_LOGS_FLOW_SCHEDULE,
   FETCH_EXECUTION_LOGS,
   SET_EXECUTION_LOGS,
   ADD_STEP_INFO,
   SET_REPORT_TYPE,
   SHOW_CALENDAR_DIALOG,
   HIDE_CALENDAR_DIALOG,
   SET_EXECUTION_BATCH_DATE_TIME,
   SET_SELECTED_LOG_NODE_ID,
   CLEAR_SELECTED_LOG_NODE_ID,
   FILTER_AND_ADD_EXECUTION_REPORT,
   CLEAR_FLOW_EXECUTION_REPORTS,
   SET_CURRENT_EXECUTION_REPORT_SESSION_ID,
   END_EXECUTION_REPORT,
   ADD_REPORT_STATE,
   RESET_EXECUTION_REPORTS,
   SET_EXECUTOR_SOCKET_DOWN
} from "redux/constants/flowDesigner";

export const setFlowExecutionFailedReset = () => ({
   type: SET_FLOW_EXECUTION_FAILED_RESET
});
export const setFlowExecutionFailed = () => ({
   type: SET_FLOW_EXECUTION_FAILED
});
export const addExecutionReport = (payload) => ({
   type: ADD_EXECUTION_REPORT,
   payload
});
export const endExecutionReport = (payload) => ({
   type: END_EXECUTION_REPORT,
   payload
});
export const addReportState = (payload) => ({
   type: ADD_REPORT_STATE,
   payload
});
export const executeFlow = (tenant_id, input) => ({
   type: EXECUTE_FLOW,
   payload: { tenant_id, input }
});

export const showFlowUsageDialog = (payload) => ({
   type: SHOW_FLOW_USAGE_DIALOG,
   payload
});
export const hideFlowUsageDialog = () => ({
   type: HIDE_FLOW_USAGE_DIALOG
});
export const cancelFlowExecution = (tenant_id) => ({
   type: CANCEL_FLOW_EXECUTION,
   payload: { tenant_id }
});
export const fetchExecutionLogs = (tenant_id) => ({
   type: FETCH_EXECUTION_LOGS,
   payload: { tenant_id }
});
export const fetchExecutionLogsFlowSchedule = (tenant_id, item_id) => ({
   type: FETCH_EXECUTION_LOGS_FLOW_SCHEDULE,
   payload: { tenant_id, item_id }
});
export const setExecutionLogs = (payload) => ({
   type: SET_EXECUTION_LOGS,
   payload
});
export const addStepInfo = (payload, sessionId) => ({
   type: ADD_STEP_INFO,
   payload: {
      ...payload,
      sessionId
   }
});
export const setReportType = (payload) => ({
   type: SET_REPORT_TYPE,
   payload
});
export const showCalendarDialog = () => ({
   type: SHOW_CALENDAR_DIALOG
});
export const hideCalendarDialog = () => ({
   type: HIDE_CALENDAR_DIALOG
});
export const setExecutionBatchDateTime = (payload) => ({
   type: SET_EXECUTION_BATCH_DATE_TIME,
   payload
});
export const setSelectedLogNodeId = (payload) => ({
   type: SET_SELECTED_LOG_NODE_ID,
   payload
});
export const clearSelectedLogNodeId = () => ({
   type: CLEAR_SELECTED_LOG_NODE_ID
});

export const filterAndAddExecutionReport = (payload) => ({
   type: FILTER_AND_ADD_EXECUTION_REPORT,
   payload
});

export const clearFlowExecutionReports = (payload) => ({
   type: CLEAR_FLOW_EXECUTION_REPORTS,
   payload
});
export const setCurrentExecutionReportSessionId = (payload) => ({
   type: SET_CURRENT_EXECUTION_REPORT_SESSION_ID,
   payload
});
export const resetExecutionReports = (payload) => ({
   type: RESET_EXECUTION_REPORTS,
   payload
});
export const setExecutorSocketDown = (payload) => ({
   type: SET_EXECUTOR_SOCKET_DOWN,
   payload
});
